module.exports = __webpack_public_path__ + "media/images/log/log-title-icon-acddbeaca436f542a2cd52b815e7bea6.svg";